module.exports = __webpack_public_path__ + "img/zhuzi.d6236c3b.png";